import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/about',
    component: () => import('@/views/AboutView.vue'),
    meta: { title: '企业介绍' }
  },
  {
    path: '/products',
    component: () => import('@/views/ProductsView.vue'),
    meta: { title: '产品展示' }
  },
  {
    path: '/products/:id',
    component: () => import('@/views/ProductDetailView.vue'),
    meta: { title: '产品详情' }
  },
  {
    path: '/news',
    component: () => import('@/views/NewsView.vue'),
    meta: { title: '新闻资讯' }
  },
  {
    path: '/news/:id',
    component: () => import('@/views/NewsDetailView.vue'),
    meta: { title: '新闻详情' }
  },
  {
    path: '/contact',
    component: () => import('@/views/ContactView.vue'),
    meta: { title: '联系我们' }
  },
  {
    path: '/admin',
    component: () => import('@/views/AdminView.vue'),
    meta: { title: '后台管理', hideHeader: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} - 康福宝` : '康福宝 - 专业医疗健康管理方案提供商'
})

export default router
